/**
 * MapToolbar — compact icon buttons for map controls.
 */

import React from 'react';
import type { BasemapStyle } from '../types/mapTypes';
import MapStyleControl from './MapStyleControl';

interface MapToolbarProps {
  basemap: BasemapStyle;
  onBasemapChange: (style: BasemapStyle) => void;
  onToggleLayers: () => void;
  showLayersPanel: boolean;
  onToggleLegend: () => void;
  onFitBounds: () => void;
}

export default function MapToolbar({
  basemap,
  onBasemapChange,
  onToggleLayers,
  showLayersPanel,
  onToggleLegend,
  onFitBounds,
}: MapToolbarProps) {
  return (
    <div className="flex flex-col gap-2">
      <MapStyleControl current={basemap} onChange={onBasemapChange} />

      <button
        onClick={onToggleLayers}
        title="Toggle layers panel"
        className={`w-10 h-10 rounded-lg shadow-md flex items-center justify-center transition-colors ${
          showLayersPanel
            ? 'bg-emerald-600 text-white'
            : 'bg-white text-slate-600 hover:bg-slate-50'
        }`}
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      </button>

      <button
        onClick={onToggleLegend}
        title="Toggle legend"
        className="w-10 h-10 rounded-lg shadow-md bg-white text-slate-600 hover:bg-slate-50 flex items-center justify-center transition-colors"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
        </svg>
      </button>

      <button
        onClick={onFitBounds}
        title="Fit to all data"
        className="w-10 h-10 rounded-lg shadow-md bg-white text-slate-600 hover:bg-slate-50 flex items-center justify-center transition-colors"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
        </svg>
      </button>
    </div>
  );
}
